import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const Moto = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  const SumitMoto =
    "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735559882/sumit_moto_iv6nli.jpg";
  const AshutoshValues =
    "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735559873/ashutosh_values2_wpxibf.jpg";
  return (
    <>
      <div
        className="container moto-container rounded py-5"
        style={{
          background: "linear-gradient(to right, #dc2430, #7b4397)",
          WebkitBackground: "linear-gradient(to right, #dc2430, #7b4397)",
        }}
      >
        <div className="row align-items-center justify-content-center text-white p-3">
          <div className="col-lg-6 text-center text-lg-start mb-4 mb-lg-0">
            <h3 className="display-4">Our Moto</h3>
            <p className="lead text-left">
              At Shine International School, we believe in nurturing every
              student's unique potential through a blend of academic excellence,
              character development, and creative expression. Our mission is to
              empower young minds with the skills and values they need to become
              future leaders and responsible global citizens. With a strong
              foundation in the CBSE curriculum and a commitment to holistic
              education, we strive to create an environment that inspires
              curiosity, fosters innovation, and promotes lifelong learning.
            </p>
          </div>
          <div className="col-lg-6 text-center">
            <img
              src={SumitMoto}
              data-aos="zoom-in-up"
              className="img-fluid rounded"
              alt="Moto Image"
            />
          </div>
        </div>
        <div className="row align-items-center justify-content-center text-white p-3">
          <div className="col-lg-6 text-center text-lg-start mb-4 mb-lg-0 mt-5">
            <img
              src={AshutoshValues}
              data-aos="zoom-in-up"
              className="img-fluid rounded"
              alt="Moto Image"
            />
          </div>
          <div className="col-lg-6 ">
            <h3 className="display-4 mt-3">Our Values</h3>
            <p className="lead text-left">
              At Shine International School, our core values define who we are
              and guide everything we do. We prioritize integrity, respect, and
              compassion as the foundation of a vibrant school community. We
              foster a culture of inclusivity, where every student feels valued
              and empowered to reach their full potential. Emphasizing
              collaboration, resilience, and a growth mindset, we prepare our
              students to face challenges with confidence and adaptability. By
              promoting social responsibility, ethical behavior, and a global
              perspective, we aim to cultivate well-rounded individuals who
              contribute positively to society and the world.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Moto;
